import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TerminosCondicionesComponent),
      multi: true
    }]
})
export class TerminosCondicionesComponent implements ControlValueAccessor {
  @Output() terminos_aceptados_change: EventEmitter<boolean> = new EventEmitter<boolean>();
  terminosAceptados: boolean = false;
  private onChange = (value: boolean) => { };
  private onTouched = () => { };

  writeValue(value: boolean): void {
    this.terminosAceptados = value || false;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: boolean): void {
    this.terminosAceptados = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.onChange(value);
  }
}
